import React, { CSSProperties } from 'react';
import { Node } from 'posthtml-parser';
import { camelCase, mapKeys } from 'lodash';

import {
  isTextNode,
  isComment,
  parseStyleString,
  decodeHtmlEntities,
} from './utils';

export const AstNode = ({ node }: any) => {
  const { tag, attrs, content } = node;
  const children = !content ? null : (content as Node[]);

  if (isTextNode(node)) {
    if (isComment(node)) {
      return null;
    }
    return <>{decodeHtmlEntities(String(node))}</>;
  }

  let style: CSSProperties = {};
  if (typeof attrs?.style === 'string') {
    style = { ...style, ...parseStyleString(attrs.style) };
  }

  const camelCaseKeys = mapKeys(attrs, (_, k) => {
    if (k.includes('xmlns')) {
      return k;
    }
    if (k === 'class') {
      return 'className';
    }
    if (k === 'cellpadding') {
      return 'cellPadding';
    }
    if (k === 'cellspacing') {
      return 'cellSpacing';
    }
    return camelCase(k);
  });
  const props = {
    ...camelCaseKeys,
    style,
  };

  const element = tag as string;

  return React.createElement(
    element,
    props ?? {},
    children?.map((child) => <AstNode key={`${Math.random()}`} node={child} />),
  );
};
